export { homePage } from './home';
export { ondeEncontrarPage } from './onde-encontrar';
export { faleConoscoPage } from './fale-conosco';
export { loginPage } from './login';
export { minhasComprasPage } from './minhas-compras';
